import { Answer, Question, QuestionnaireService } from "@/types/questionnaire";
import { useState } from "react";
import parse from 'html-react-parser';

interface Properties {
    question: Question
    setQuestionCompleted: (completed: boolean) => void
}

function QuestionRadio(properties: Properties): JSX.Element {
    const NOT_SELECTED = -2;

    const question: Question = properties.question;

    const answers: Answer[] = question.answers;
    const initialValue: number = (() => {
        for(let i: number = 0; i < answers.length; i++) {
            if(answers[i].checked) return i;
        }
        return NOT_SELECTED;
    })()

    const [valueSelected, setValueSelected] = useState<number>(initialValue);

    const onClickCheckbox = (index: number) => {
        if( valueSelected >= 0 ) {
            answers[valueSelected].checked = false;
        }
        // TEMP, for debugging
        // answers[index].checked = true;
        answers[index].checked = !answers[index].checked;
        properties.setQuestionCompleted(answers[index].checked);
        setValueSelected(answers[index].checked ? index : -1);
    }

    const onClickLabel = (index: number) => {
        onClickCheckbox(index);
    }

    const inputElement = (answer: Answer, answerIndex: number): JSX.Element => {
        return (
            <>
                <div key={answer.id} className="inline-radio">
                <input
                    className="lg:self-end cursor-pointer"
                    type="checkbox"
                    checked={answer.checked}
                    onChange={() => onClickCheckbox(answerIndex)}
                />
                <h5 className="flex-1 lg:text-center lg:self-center text-xl font-normal"
                    onClick={() => onClickLabel(answerIndex) }
                >{ parse(QuestionnaireService.AnswerGetContent(answer)) }</h5>
                </div>
            </>
        )
    }

    return (
        <>
            <div key={question.id} className="radio-container mb-4">
                <h5 className="flex-1 mb-4">{parse(question.title)}</h5>
                <div className="radio-options">
                    {question.answers.map((answer: Answer, answerIndex: number) => { return inputElement(answer, answerIndex); })}
                </div>
            </div>
        </>
    )
}

export default QuestionRadio;